
import React, { useContext }  from 'react';
import Button from '@material-ui/core/Button';

import { FormContext } from 'core/FormProvider';
import { ContextWidget, ContextFormControlWidget } from 'form/Contexed';
import { InputWidget } from 'form/InputWidget';
import { CheckboxWidget } from 'form/Checkbox';
import FormGroup from 'form/FormGroup';
import { CounterpartyForm } from './CounterpartyForm';
import { AsyncAutocompleteWidget } from 'form/AutocompleteWidget';
import { AutocompleteMultipleWidget2 } from "form/AutocompleteMultipleWidget2";
import {UserContext} from "components/User";


export function ClientAddForm() {
  const userContext = useContext(UserContext);
  return (
    <FormContext.Consumer>
      {context => {
        const { item } = context;

        return (
          <FormGroup>

            <ContextWidget
              name={'name'}
              WidgetComponent={InputWidget}
              widgetProps={{
                label: 'Название',
                required: true
              }}
            />

            <div className={'mb-15'}>
              <ContextWidget
                name={'is_active'}
                WidgetComponent={CheckboxWidget}
                widgetProps={{
                  label: 'Активность'
                }}
              />
            </div>

            <ContextFormControlWidget
              name={`personal_manager`}
              WidgetComponent={AsyncAutocompleteWidget}
              widgetProps={{
                url: 'account/staff',
                label: 'Персональный менеджер',
                optionLabel: 'short_name',
                filter: {
                  departments: userContext.data.department_active.id
                }
              }}
            />

            {item.counterparties.map((counterparty, index) =>
              <CounterpartyForm
                key={index}
                index={index}
                context={context}
                counterparty={counterparty}
              />
            )}

            <Button
              type="button"
              variant="outlined"
              onClick={() => context.pushArrayValue('counterparties', {contacts: [{emails: []}]})}
            >
              + Добавить контрагента
            </Button>

            <div className={'mt-30'}>
              <ContextFormControlWidget
                name={`points`}
                WidgetComponent={AutocompleteMultipleWidget2}
                widgetProps={{
                  url: 'catalog/point',
                  label: 'Точки',
                  optionLabel: 'label'
                }}
              />
            </div>
          </FormGroup>
        )
      }}
    </FormContext.Consumer>
  )
}
